// extracted by mini-css-extract-plugin
export default {"confirmationBody":"ConfirmationModal_confirmationBody__oCXle","confirmationFooter":"ConfirmationModal_confirmationFooter__cmeXr"};